module.exports = __webpack_public_path__ + "img/40f5.784118f6.jpg";